// extracted by mini-css-extract-plugin
module.exports = {"liveBtn":"DaoPendingButton_liveBtn__YlGRE","viewBtn":"DaoPendingButton_viewBtn__vcd1P"};